import { render } from "./PrescriberTreatmentAreaDetails.vue?vue&type=template&id=77fc4674&scoped=true"
import script from "./PrescriberTreatmentAreaDetails.vue?vue&type=script&lang=js"
export * from "./PrescriberTreatmentAreaDetails.vue?vue&type=script&lang=js"

import "./PrescriberTreatmentAreaDetails.vue?vue&type=style&index=0&id=77fc4674&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77fc4674"]])

export default __exports__